<template>
  <div class="stepDescription">
    <h2 class="text-xl font-bold mb-1">Em qual operação deseja trabalhar?</h2>
  </div>

  <div
    v-for="option in options"
    :key="option.id"
    class="cardTypeVehicle"
    @click="select(option)"
    v-bind:class="{ selected: option.isSelected }"
  >
    <div class="cardTypeVehicle__header">
      <div class="header__title">
        <h2 class="typeVehicle">{{ option.name }}</h2>
      </div>
      <div class="header__icon">
        <img src="../../../../public/images/arrow-forward.svg" class="arrow-forward"
             @click="select(option)">
      </div>
    </div>
    <div class="cardTypeVehicle__description">
      <p class="descriptionTypeVehicle">{{ option.description }}</p>
    </div>
  </div>
</template>

<script>
import FooterButton from '../../components/FooterButton.vue'
import { useRouter } from 'vue-router'

export default {
  components: {
    FooterButton
  },

  setup(props) {
    const router = useRouter();

    const options = [
      {
        id: 'shopee',
        name: 'Shopee',
        description: 'Solicite informações com seu dispatcher',
        isSelected: false,
      },
      {
        id: '4wheels',
        name: 'Demais operações',
        description: 'Operações 4 Rodas',
        isSelected: false,
      }
    ];

    const select = (option) => {
      if (option.id === 'shopee') {
        router.push({ name: 'Hub' });
      } else {
        router.push({ name: 'Password' });
      }
    };

    return {
      options,
      select,
    };
  },
}
</script>
